import { render } from "./NewsDetail.vue?vue&type=template&id=02ade74e&ts=true"
import script from "./NewsDetail.vue?vue&type=script&lang=ts"
export * from "./NewsDetail.vue?vue&type=script&lang=ts"

import "./NewsDetail.vue?vue&type=style&index=0&id=02ade74e&lang=scss"

import exportComponent from "E:\\vueapp\\xm-cms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__